'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperDelivery = exports.PlusLabel = exports.Wrapper = undefined;

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  width: 9px;\n  height: 16px;\n  font-family: Nunito Sans;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6E0AD6;\n  ', ';\n'], ['\n  width: 9px;\n  height: 16px;\n  font-family: Nunito Sans;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6E0AD6;\n  ', ';\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  margin-top: 1px;\n'], ['\n  margin-top: 1px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _View = require('../../atoms/View');

var _View2 = _interopRequireDefault(_View);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = (0, _styledComponents2.default)(_View2.default)(_templateObject);

var PlusLabel = _styledComponents2.default.span(_templateObject2, function (props) {
  return props.reduced ? 'margin: 0px 2px 0 3px;' : 'margin: 0px 6px 0 7px;';
});

var WrapperDelivery = (0, _styledComponents2.default)(_View2.default)(_templateObject3);

exports.Wrapper = Wrapper;
exports.PlusLabel = PlusLabel;
exports.WrapperDelivery = WrapperDelivery;